import { render } from "./VendorWorkMonthlyCalendarDetail.vue?vue&type=template&id=521d6a1a&scoped=true"
import script from "./VendorWorkMonthlyCalendarDetail.vue?vue&type=script&lang=js"
export * from "./VendorWorkMonthlyCalendarDetail.vue?vue&type=script&lang=js"

import "./VendorWorkMonthlyCalendarDetail.vue?vue&type=style&index=0&id=521d6a1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521d6a1a"]])

export default __exports__